import {
  l,
  t,
  bindLanguage,
  languageSelect,
  localizeShell,
} from "./core/i18n.js";
import "./styles/original.css";
import "./styles/product.css";
import "./styles/motion.css";
import "./styles/auth.css";
import "./styles/dayx.css";
import "./styles/landing-demos.css";
import "./styles/landing-product-demos.css";
import "./styles/dashboard.css";
import "./styles/floating-timer.css";
import "./styles/planning.css";
import "./styles/plan-table-view.css";
import "./styles/workspace-tools.css";
import "./styles/owner.css";
import "./styles/night.css";
import "./styles/appearance.css";
import "./styles/landing-light.css";
import "./styles/landing-type.css";
import "./styles/command-palette.css";
import "./styles/legal.css";
import "./styles/kun.css";
import "./styles/mobile.css";
import { bindAppearance } from "./features/appearance.js";
import { bindPresence } from "./services/presence.js";
import {
  renderLanding,
  refreshLandingAccount,
  dayxMark,
} from "./features/landing.js";
import { renderAuthPage } from "./features/auth-page.js";
import {
  bindExperience,
  showHome,
  showWorkspace,
  setExperienceReady,
} from "./features/experience.js";
import { init, dateKey } from "./core/model.js";
import { runtime } from "./core/runtime.js";
import { bindShell } from "./features/events.js";
import { render } from "./features/views.js";
import { bindAccount, updateAccountUI } from "./features/account.js";
import { bootstrapStorage, getSyncInfo } from "./services/storage.js";
import { updatePageMetadata } from "./core/seo.js";
import { bindAccessibility, routes } from "./services/shell.js";
import { bindReports } from "./features/reports.js";
import { bindDatePicker } from "./features/date-picker.js";
import { bindShortcuts } from "./features/shortcuts.js";
import { bindFullscreen } from "./features/fullscreen.js";
import { toast } from "./core/navigation.js";
import { AUTH_ROUTES } from "../shared/seo.js";
renderLanding();
bindAppearance();
window.addEventListener("planner:sync", refreshLandingAccount);
document.querySelector(".brand > a").innerHTML = dayxMark;
document.getElementById("sidebarLanguage").innerHTML = languageSelect();
bindLanguage();
bindExperience();
bindFullscreen();
let workspaceReady = false;
window.addEventListener("dayx:language", () => {
  const authValues =
    document.body.dataset.presentation === "auth"
      ? [...document.querySelectorAll("#authForm input")].map((el) => ({
          id: el.id,
          value: el.value,
          type: el.type,
        }))
      : [];
  const scroll = window.scrollY;
  renderLanding();
  document.getElementById("sidebarLanguage").innerHTML = languageSelect();
  localizeShell();
  if (!workspaceReady) {
    updatePageMetadata();
    return;
  }
  render();
  updateAccountUI();
  if (document.body.dataset.presentation === "auth") {
    renderAuthPage();
    for (const field of authValues) {
      const el = document.getElementById(field.id);
      if (el) {
        el.value = field.value;
        el.type = field.type;
        if (field.id === "authPassword" && field.type === "text") {
          const toggle = document.getElementById("togglePassword");
          toggle.textContent = t("Hide");
          toggle.setAttribute("aria-label", t("Hide password"));
          toggle.setAttribute("aria-pressed", "true");
        }
      }
    }
  }
  updatePageMetadata(document.title);
  window.scrollTo({ top: scroll, behavior: "instant" });
});

async function boot() {
  await bootstrapStorage();
  bindPresence();
  refreshLandingAccount();
  runtime.renderedDay = dateKey(new Date());
  const route = location.pathname.split("/")[1];
  runtime.page = routes.includes(route) ? route : "today";
  setExperienceReady();
  bindShell();
  bindAccessibility();
  bindAccount();
  bindReports();
  bindDatePicker();
  bindShortcuts();
  window.addEventListener("planner:sync", () => {
    if (
      document.body.dataset.presentation === "auth" &&
      getSyncInfo().requiresLogin &&
      document.getElementById("authForm")?.hidden
    )
      renderAuthPage();
  });
  init();
  workspaceReady = true;
  if (new URLSearchParams(location.search).get("account") === "deleted") {
    history.replaceState(history.state, "", location.pathname);
    toast("Your account and its data were deleted.");
  }
  if (AUTH_ROUTES.includes(location.pathname)) renderAuthPage();
  window.addEventListener("popstate", () => {
    if (AUTH_ROUTES.includes(location.pathname)) {
      document.body.dataset.presentation = "auth";
      document.body.classList.remove("table-view");
      renderAuthPage();
      return;
    }
    if (location.pathname === "/") {
      showHome(false);
      return;
    }
    const route = location.pathname.split("/")[1];
    showWorkspace(routes.includes(route) ? route : "today", false);
    render();
  });
  if (import.meta.env.PROD && "serviceWorker" in navigator)
    navigator.serviceWorker.register("/sw.js").catch(() => {});
}
boot().catch((error) => {
  console.error(error);
  const page = document.getElementById("appPage");
  page.textContent = l(
    "Your planner could not open. Refresh the page to try again.",
  );
  const retry = document.createElement("button");
  retry.className = "btn black";
  retry.textContent = l("Refresh");
  retry.onclick = () => location.reload();
  page.append(retry);
});
